import "../pages/Courses/CourseWorkspaceLayout.css";
import { CourseRealtimeProvider } from "../components/CourseRealtime/CourseRealtime";
import { courseApiEnabled, coursesEnabled } from "../config/courseFeatures";
import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CourseProvider } from "../pages/Courses/CourseContext";
import Navbar from "../components/Header/Navbar";
import Sidebar from "../components/Header/Sidebar";
import IncomingMessagePrompt from "../components/Thread/IncomingMessagePrompt";
import { twMerge } from "tailwind-merge";
import { sideBarOptions } from "../config/sideBarOptions";
import { fetchLoyaltyProgress, fetchReferralDiscountEligibility } from "../store/thunks/orderThunk";

function RootLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isCoursePage = /^\/courses(?:\/|$)/.test(location.pathname);
  const courseWorkspace = /^\/courses\/COURSE-[1-9]\d{4,}\/(messages|payments|payment-return)\/?$/.test(location.pathname);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [smallScreen, setIsSmallScreen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 1280);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(fetchReferralDiscountEligibility());
    dispatch(fetchLoyaltyProgress());
  }, [dispatch, location.pathname]);

  return (
    <>
      <div className={`flex flex-row h-screen w-full overflow-hidden min-w-[320px] overflow-x-hidden${courseWorkspace ? " course-workspace-layout" : ""}`}>
        <div
          style={{ minHeight: "654px" }}
          className={twMerge(
            "xl:w-[256px] xl:min-w-[256px] xl:max-w-[256px]",
            smallScreen && isSidebarOpen
              ? "max-xl:fixed max-xl:bottom-0 max-xl:top-0 max-xl:h-screen max-xl:z-50 min-w-[256px]"
              : "h-0 w-0"
          )}
        >
          <Sidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            smallScreen={smallScreen}
            Menus={sideBarOptions}
          />
        </div>
        <div className={`flex flex-col flex-grow w-full ${isCoursePage ? "courses-dashboard-column" : "overflow-y-auto"}`}>
          {!courseWorkspace && <Navbar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />}
          <main className={`flex flex-grow w-full overflow-y-auto${courseWorkspace ? " course-workspace-content" : ""}`}>
            <Outlet />
          </main>
        </div>
      </div>
      <IncomingMessagePrompt />
    </>
  );
}

export default function CustomerLayout() {
  const user = useSelector(state => state.auth.user);
  return <CourseProvider timezone={user?.timezone} key={user?._id || user?.userId || user?.email || "anonymous"}><CourseRealtimeProvider enabled={courseApiEnabled && coursesEnabled} brand="course_pivot"><RootLayout /></CourseRealtimeProvider></CourseProvider>;
}
